import cx from "classnames";
import { Link } from "react-router-dom";

import useLegacyBreakpoint from "@/hooks/use-legacy-breakpoint";
import { SessionManager } from "@/services/SessionManager";

const footerItemBase = "text-[11px] px-[10px] relative text-gray-400 font-medium";
const footerItemSeparator =
  "after:content-[''] after:block after:absolute after:w-px after:h-3 after:left-0 after:top-0 after:bg-gray-400";

const Footer = ({ isSidebar = false }) => {
  const breakpoint = useLegacyBreakpoint();
  const isMobile = breakpoint === "mobile";
  const showFullFooter = !isMobile && !isSidebar;
  return (
    <div className="py-3">
      <div className={cx(!isSidebar && "w-full px-5 mx-auto box-border")}>
        <div className="flex justify-center items-center">
          <div className="[&_a:hover]:underline">
            <Link to="/privacy" target="_blank" rel="noopener noreferrer" className={footerItemBase}>
              Privacy {showFullFooter && "policy"}
            </Link>
          </div>
          <div className="[&_a:hover]:underline">
            <Link to="/terms" target="_blank" rel="noopener noreferrer" className={cx(footerItemBase, footerItemSeparator)}>
              Terms {showFullFooter && "of service"}
            </Link>
          </div>
          <div className="[&_a:hover]:underline">
            <a
              href="https://docs.replicated.com/release-notes/rn-vendor-platform"
              className={cx(footerItemBase, footerItemSeparator)}
            >
              {SessionManager.getBuildVersion()}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
